var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C77.6142 0 100 22.3858 100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0ZM81 45C81 45 68.0352 51.3154 59.0176 55.2422C49.9999 59.169 50.0001 59.169 40.9824 55.2422C34.5253 52.4304 19 45 19 45V70C19 72.2091 20.7909 74 23 74H77C79.2091 74 81 72.2091 81 70V45ZM23 31C20.7909 31 19 32.7909 19 35V39.6914C19 39.6914 34.5253 47.4578 40.9824 50.3965C49.9998 54.5003 50.0002 54.5003 59.0176 50.3965C68.0352 46.2925 81 39.6914 81 39.6914V35C81 32.7909 79.2091 31 77 31H23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.26585aba73101436e154cb2d5b32c9b3.svg";
export { ForwardRef as ReactComponent };